import React from 'react';
import { Col, Image, Row } from 'react-bootstrap';

const ByPactopia = ({ width = '' }) => {
  return (
    <Row className="auth-logo">
      <Col className="logo-container text-center">
        <div className="text-muted">
          <small>Un producto de</small>
        </div>
        <div className="pactopia-logo-container">
          <Image
            width={width}
            src="/img/logo-pactopia.png"
            className="auth-logo-img pactopia-logo"
            fluid={true}
          />
        </div>
      </Col>
    </Row>
  );
};

export default ByPactopia;
